<template>
	<div class="filters-box-row">
		<div class="filters-container" :style="collapse ? 'height: 50px' : ''">
			<div class="input-box">
				<span>常购单名称：</span>
				<el-input
					v-model="name"
					placeholder="请输入常购单名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
				></el-input>
			</div>
			<div class="input-box">
				<span>常购单状态：</span>
				<el-select v-model="disabledflag" class="name-input" size='mini'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="0" label="启用"></el-option>
					<el-option :value="1" label="停用"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>商品名称：</span>
				<el-input
					v-model="productname"
					placeholder="请输入商品名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
				></el-input>
			</div>
			<div class="input-box">
				<span>店铺级大类：</span>
				<el-select v-model="bcId" class="name-input" size='small' @change="bcChange">
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in bc">
						<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id" :disabled="item.disabledflag"/>
					</template>
				</el-select>
			</div>
			<div class="input-box" v-if="bigcategoryview === 1">
				<span>店铺级小类：</span>
				<el-select v-model="scId" class="name-input" size='small'>
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in sc">
						<el-option :value="item.id" :label="item.name" :key="item.id" :disabled="item.disabledflag"></el-option>
					</template>
				</el-select>
			</div>
			<div class="input-box">
				<span>适用客户：</span>
				<el-input
					v-model="customerName"
					placeholder="请输入适用客户名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
				></el-input>
			</div>
			<div class="input-box">
				<span>适用门店：</span>
				<el-input
					v-model="shopName"
					placeholder="请输入适用门店名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
				></el-input>
			</div>
		</div>
		<div class="search-right-wrap">
			<el-button size="small" type="text" class="btn Yahei" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
			</el-button>
			<el-button
				type="primary"
				class="btn fx-btn Yahei"
				size="small"
				@click="onSearch">查询</el-button>
			<el-button
				class="btn fx-btn Yahei"
				size="small"
				plain
				@click="clearing">清空</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Search',
	props: {

	},
	data () {
		return {
			customerName: '',
			shopName: '',
			name: '',
			disabledflag: -1,
			productname: '',
			collapse: false,
			bcId: '0',
			scId: '0',
			bc: [],
			sc: [],
			bigcategoryview: 0
		}
	},
	created () {
		this.getBigCategory()
		this.checkSmallCategory().then(res => {
			this.bigcategoryview = res.bigcategoryview
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		})
	},
	methods: {
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bcId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		bcChange (value) {
			this.scId = '0'
			this.bcId = '' + value
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		clearing () {
			this.name = ''
			this.productname = ''
			this.disabledflag = -1
			this.bcId = '0'
			this.scId = '0'
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
			this.onSearch()
		},
		onSearch () {
			let params = {
				name: this.name,
				disabledflag: this.disabledflag,
				productname: this.productname,
				customerName: this.customerName,
				shopName: this.shopName,
				bcId: this.bcId,
				scId: this.scId
			}
			this.$emit('handleSearch', params)
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	justify-content: space-between
	padding: 10px 0;
	width :100%;
	line-height :60px;
	border-bottom 1px solid #dce2fd;
	box-sizing: border-box
	.filters-container {
		display flex
		flex: 1
		flex-wrap: wrap;
		overflow: hidden
		.input-box {
			display flex
			margin-left: 20px
			span {
				display: inline-block;
				text-align: right;
				width: 85px;
				margin-right: 5px
			}
			.name-input {
				width: 160px
			}
		}
		.btn {
			height: 32px
			margin-top: 14px
			margin-left 20px
		}
	}
	.search-right-wrap {
		width: 200px;
		flex-shrink: 0;
		line-height: 50px
	}
	.Yahei {
		font-family: 'Microsoft Yahei'
	}
}
</style>
